import dxDropDownButton from "devextreme/ui/drop_down_button";
import dxList from "devextreme/ui/list";
import notify from "devextreme/ui/notify";
import moment from "moment";
import dxButton from "devextreme/ui/button";
import io, {Socket} from "socket.io-client";
import '../css/hermes.css';
import ControleSessao from "../componentes-padrao/ControleSessao";

/**
 * @typedef Notificacao
 * @property id {number}
 * @property to {number}
 * @property received {boolean}
 * @property message {string}
 * @property messageType {string}
 * @property displayTime {number}
 * @property read {boolean}
 * @property recipient {string}
 * @property createdAt {Date}
 */

export default class HermesNotifier {
    /**
     * @param {(HTMLElement, HTMLDivElement)} element
     */
    constructor(element) {
        new dxDropDownButton(element, {
            showArrowIcon: false,
            hint: "Notificações",
            icon: "fas fa-bell",
            elementAttr: {
                class: "dx-button-notificacao",
            },
            deferRendering: false,
            dropDownContentTemplate: (items, element) => {
                let readAllNotificationsDiv = $('<div style="display: flex; justify-content: center; align-items: center;"></div>')
                new dxButton(readAllNotificationsDiv, {
                    text: "Ler todas",
                    type: "success",
                    stylingMode: "text",
                    elementAttr: {
                        "class": "btn-botao-sem-margem"
                    },
                    onClick: _ => {
                        const dataSource = this.listNotificacoes.getDataSource().store()["_array"]

                        dataSource.map(msg => {
                            this.socket.emit("read_message", msg.id)
                            msg.read = true
                        })

                        this.checkUnreadMessages(dataSource)
                        this.listNotificacoes.option("dataSource", dataSource)
                    },
                })
                readAllNotificationsDiv.appendTo(element)

                let notificationsListDiv = $('<div></div>')
                new dxList(notificationsListDiv, {
                    dataSource: items,
                    searchEnabled: true,
                    keyExpr: "id",
                    displayExpr: "message",
                    noDataText: "Sem Notificações",
                    searchExpr: "message",
                    elementAttr: {
                        class: "dx-list-notificacao",
                    },
                    showScrollbar: "always",
                    useNativeScrolling: false,
                    scrollByContent: true,
                    onInitialized: (e) => this.listNotificacoes = e.component,
                    itemTemplate: (data, index) => this.getTemplateItemNotificacao(data, index),
                })
                notificationsListDiv.appendTo(element)
            },
            dropDownOptions: {
                title: "Notificações",
                showTitle: true,
                width: 350,
                maxHeight: window.innerHeight * 0.75,
            },
            onInitialized: e => this.dropDownButtonNotificacoes = e.component,
        })

        const disableNotifications = process.env.DISABLE_NOTIFICATIONS;

        if (disableNotifications === true || disableNotifications === "true") {
            return;
        }

        this.configureNotifications()
    }


    /**
     * @return {dxDropDownButton}
     */
    get dropDownButtonNotificacoes() {
        return this._dropDownButtonNotificacoes
    }

    /**
     * @param {dxDropDownButton} component
     */
    set dropDownButtonNotificacoes(component) {
        this._dropDownButtonNotificacoes = component
    }


    /**
     * @return {dxList}
     */
    get listNotificacoes() {
        return this._listNotificacoes
    }

    /**
     * @param {dxList} component
     */
    set listNotificacoes(component) {
        this._listNotificacoes = component
    }

    /**
     * @return {Socket}
     */
    get socket() {
        return this._socket;
    }

    /**
     * @param {Socket} socket
     */
    set socket(socket) {
        this._socket = socket
    }

    configureNotifications = () => {
        const socket = this.connectToSocketIo()

        const sessionID = localStorage.getItem("sessionID");

        if (sessionID) socket.auth = {sessionID};

        socket.connect();

        this.socket = socket

        socket
            .on('connect', () => {
                socket
                    .on('notify', msg => {
                        new notify({
                            position: {at: 'top', my: 'top', offset: '0 60'},
                            maxWidth: 400,
                            closeOnClick: true,
                            contentTemplate: function (contentElement) {
                                const box = $('<p />').html(msg.message);
                                $(contentElement).append(box);
                            }
                        }, msg.messageType, msg.displayTime ?? 3000)
                        const dataSource = this.listNotificacoes.getDataSource().store()["_array"]

                        dataSource.unshift(msg)

                        this.checkUnreadMessages(dataSource)
                        this.listNotificacoes.option("dataSource", dataSource)
                    })
                    .on('message_history', msg => {
                        this.checkUnreadMessages(msg)
                        this.listNotificacoes.option("dataSource", msg)
                    })
                    .on('session', ({sessionID, userID}) => {
                        socket.auth = {sessionID};
                        localStorage.setItem("sessionID", sessionID);
                        socket.userID = userID;
                    })
            })
            .on('unauthorized', msg => {
                console.error(`unauthorized: ${JSON.stringify(msg.data)}`);
                throw new Error(msg.data.type);
            })
            .on('disconnect', _ => {
                socket.off('notify')
                socket.off('message_history')
                socket.off('session')
            })
    };

    /**
     * @param {(Notificacao[], {_items: Notificacao[]})} items
     */
    checkUnreadMessages = items => {
        items = items.hasOwnProperty("_items") ? items._items : items

        const unread = items.filter(value => !value.read)

        const elementoBotao = this.dropDownButtonNotificacoes.element()
            .firstElementChild.firstElementChild
            .firstElementChild.firstElementChild

        if (unread.length > 0) {
            elementoBotao.classList.add("unread")
        } else {
            elementoBotao.classList.remove("unread")
        }
    };

    /**
     * @param {Notificacao} data
     * @param {number} index
     * @return {*|jQuery}
     */
    getTemplateItemNotificacao = (data, index) => {
        /**
         * @param {string} tipo
         * @return {string}
         */
        const getNomeIcon = (tipo) => {
            switch (tipo) {
                case "warning":
                case "error":
                    return "exclamation-triangle"
                case "success":
                    return "check"
                default:
                    return "info"
            }
        }

        /**
         * @param {number} index
         * @param {DxElement | HTMLDivElement | HTMLElement} container
         */
        const markAsRead = (index, container) => {
            this.socket.emit('read_message', data.id)

            container.previousSibling.classList.remove("hermes-unread")
            $(container).remove()

            const dataSource = this.listNotificacoes.getDataSource().store()["_array"]
            dataSource[index].read = true

            this.checkUnreadMessages(dataSource)
        }

        const content = $("<div/>")
            .addClass("item-notificacao")
            .addClass("notificacao-" + data.messageType);

        $("<div/>")
            .addClass("icone-notificacao")
            .appendTo(content)
            .append($("<div/>").addClass("fas fa-" + getNomeIcon(data.messageType)));


        const contentTexto = $("<div/>").addClass("texto-notificacao")

        $("<div/>")
            .html(data.message)
            .appendTo(contentTexto);

        $("<span/>")
            .text(moment.utc(data.createdAt).format("DD/MM/YYYY HH:mm:ss"))
            .appendTo(contentTexto)

        contentTexto.appendTo(content)

        const contentBotao = $("<div/>")
            .addClass("botao-marcar-lida-notificacao")
            .appendTo(content);

        new dxButton(contentBotao, {
            hint: "Marcar como lido",
            icon: "isnotblank",
            elementAttr: {
                style: "padding: unset;"
            },
            visible: !data.read,
            stylingMode: "contained",
            onClick: (e) => markAsRead(index, e.element)
        })

        contentBotao.children().css("padding", "2px");

        if (!data.read) contentTexto.addClass("hermes-unread")

        return content
    };

    /**
     * @return {Socket}
     */
    connectToSocketIo = () => {
        const accessToken = ControleSessao.getToken()

        return io(window.location.origin, {
            path: "/hermes/socket.io",
            autoConnect: false,
            withCredentials: true,
            extraHeaders: {
                'x-auth-token': accessToken
            },
            transportOptions: {
                polling: {
                    extraHeaders: {
                        'x-auth-token': accessToken
                    }
                }
            },
        })
    };
}
